/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 供应商上传多张图片
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<string>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/oss/filesProvider`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
